import * as React from 'react';

type Props = {
  children: React.ReactNode;
  errorComponent: React.ReactNode;
};

type State = {
  hasError: boolean;
};

export default class ErrorBoundary extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(
    error: Error,
    errorInfo: {
      componentStack: string;
    },
  ): void {
    //@ts-ignore: TODO - Sentry + Typescript
    window.Raven.captureException(error, errorInfo);
  }

  render() {
    const { children, errorComponent } = this.props;
    const { hasError } = this.state;
    return hasError ? errorComponent : children;
  }
}
